
import React from 'react';
import { Subscription } from '../hooks/subscription/types';
import { 
  PaymentFailedAlert,
  SuspendedSubscriptionAlert,
  GenericSubscriptionAlert
} from './subscription-alerts';

interface SubscriptionAlertProps {
  isSubscribed: boolean;
  currentSubscription: Subscription | null;
  isDashboard?: boolean;
}

export const SubscriptionAlert = ({ 
  isSubscribed, 
  currentSubscription,
  isDashboard = false
}: SubscriptionAlertProps) => {
  if (!isSubscribed || !currentSubscription) {
    return null;
  }
  
  // Show different alerts based on context (dashboard vs pricing page)
  switch (currentSubscription.subscription_status) {
    case 'payment_failed':
      return <PaymentFailedAlert />;
      
    case 'suspended':
      return <SuspendedSubscriptionAlert />;
      
    // Don't show alerts for active or cancelled subscriptions on pricing page
    // but allow them to show on dashboard if needed
    case 'active':
    case 'cancelled':
      return null;
      
    // Only show generic alert for unexpected states
    default:
      return <GenericSubscriptionAlert status={currentSubscription.subscription_status} />;
  }
};
